import {focusable, IFocusableComponentInjectedProps} from 'focus-manager/web';
import * as React from 'react';

import ReservedValue from '../Constants/ReservedValue';
import Backspace from '../Icons/Backspace';

interface IKeyProps extends IFocusableComponentInjectedProps {
    isDoubleWidth?: boolean;
    isSpaceBar?: boolean;
    value?: string;
}

const getVisibleValue = (value: string = '') => {
    const reservedValues: string[] = [ReservedValue.SPACE, ReservedValue.BACKSPACE];

    return reservedValues.includes(value) ? '' : value;
};

const Key: React.FC<IKeyProps> = props => {
    const className = ['key', props.isDoubleWidth ? 'key--double-width' : '', props.isSpaceBar ? 'key--space-bar' : '']
        .filter(Boolean)
        .join(' ');

    const Icon = props.value === ReservedValue.BACKSPACE ? Backspace : null;

    return (
        <button
            ref={props.setFocusableElementRef}
            className={className}
            tabIndex={-1}
            data-value={getVisibleValue(props.value)}
        >
            {Icon && <Icon />}
        </button>
    );
};

export default focusable(Key);
